const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function searchBook(book) {
  const res = await fetch(`${API}/library/search`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(book),
  });
  if (!res.ok) {
    throw new Error(`Request failed: ${res.status}`);
  }
  return res.json();
}
